export const appCode = 'fund-management'
